import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PublicLayout({
  user,
  showSearchPanel,
  setShowSearchPanel,
  isArticlePage,
  handleLogin,
  handleFirstLogin,
  handleLogout
}) {
  return (
    <>
      <Header
        showSearchPanel={showSearchPanel}
        onToggleSearch={() => setShowSearchPanel(prev => !prev)}
        hideSearch={isArticlePage}
      />

      <main className="page-layout">
        <div className="main-content">
          <Outlet />
        </div>
      </main>

      <Footer
        user={user}
        onLogin={handleLogin}
        onFirstLogin={handleFirstLogin}
        onLogout={handleLogout}
      />
    </>
  );
}
